// Compass
// HB9
import Carousel from '@common/components/Carousel';
import { getFilteredSliderImages } from '@common/models/Slider';
import { SliderSliceType } from '@common/store/slider/slice';
import { isMobile } from '@common/utils';
import SliderCta from '@components/SliderCta';
import AspectRatio from '@lib/AspectRatio';
import Image from '@lib/Image';
import classnames from 'classnames';
import React, { useState } from 'react';

export interface BannerCarousalProps {
  slider: SliderSliceType;
}

const BannerCarousal: React.FC<BannerCarousalProps> = ({ slider }) => {
  const MOBILE_ASPECT_RATIO = 414 / 321;
  const DESKTOP_ASPECT_RATIO = 1440 / 563;
  const filteredImages = getFilteredSliderImages({ slider, shouldImageBePresent: true });
  const [hover, setHover] = useState(false);
  if (!filteredImages?.length) {
    return null;
  }
  return (
    <div
      className={classnames({
        'slider-7 slider container mx-auto px-0': filteredImages.length,
        ' hidden': !filteredImages.length,
      })}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <AspectRatio aspectRatio={isMobile() ? MOBILE_ASPECT_RATIO : DESKTOP_ASPECT_RATIO}>
        <Carousel autoPlay={filteredImages?.length > 1 ? (hover ? null : 5000) : null}>
          {filteredImages.map((banner, index) => {
            return (
              <AspectRatio key={banner.slider} aspectRatio={isMobile() ? MOBILE_ASPECT_RATIO : DESKTOP_ASPECT_RATIO}>
                <div className="w-full h-full relative" key={banner.slider}>
                  <Image
                    src={banner.image}
                    className="object-cover object-center-top rounded-3xl"
                    alt={`Hero Banner ${index + 1}`}
                    noDefaultFit
                  />
                  <div
                    className={classnames(
                      'flex flex-col items-center justify-center h-full w-full rounded-3xl absolute top-0',
                      {
                        'bg-slider-overlay': banner.heading || banner.subheading,
                      },
                    )}
                  >
                    {banner.showCustomText ? (
                      <>
                        <div
                          className="text-slider-text text-24 md:text-54 font-bold leading-35 md:leading-70 w-full text-center"
                          font-customisation="section-heading"
                          color-customisation="banner-heading"
                        >
                          {banner.heading}
                        </div>
                        {banner.subheading ? (
                          <div
                            className="text-slider-text text-24 md:text-54 leading-35 md:leading-70 font-bold w-full text-center"
                            font-customisation="para-text"
                            color-customisation="banner-subHeading"
                          >
                            {banner.subheading}
                          </div>
                        ) : null}
                      </>
                    ) : null}

                    <br />
                    {banner.link && banner.showButton ? <SliderCta link={banner.link} text={banner.label} /> : null}
                  </div>
                </div>
              </AspectRatio>
            );
          })}
        </Carousel>
      </AspectRatio>
    </div>
  );
};

export default BannerCarousal;
